<template>
  <layout-form>
    <input-avatar />
    <input-last-name />
    <input-first-name />
    <input-email />
  </layout-form>
</template>

<script>
import LayoutForm from '@/lib//Layout/Form'
import InputAvatar from './InputAvatar'
import InputLastName from './InputLastName'
import InputFirstName from './InputFirstName'
import InputEmail from './InputEmail'

export default {
  components: {
    LayoutForm,
    InputAvatar,
    InputLastName,
    InputFirstName,
    InputEmail
  }
}
</script>
